import React from "react";
import LuniShowerHotelRow from "./LuniShowerHotelRow";
import SortableTableHeader from "../../HotelPage/SortableTableHeader";
import HotelsSummary from "../../Home/HotelsSummary";
import { AiOutlineSearch, AiOutlineClose } from "react-icons/ai";

/**
 * `loadingStats` reste le drapeau global (états vides de la page) ; `statsPendingIds`
 * donne le détail par hôtel, pour que seules les lignes concernées soient re-rendues.
 */
const LuniShowerHotelsTable = ({ hotels, onUpdateStatus, onEditDescription, sortState, onSort, loadingStats = false, statsPendingIds = null, searchTerm, setSearchTerm }) => {
  const isStatsLoading = (hotel) => (statsPendingIds ? statsPendingIds.has(hotel.id) : loadingStats);

  if (hotels.length === 0 && !loadingStats) {
    return (
      <div className="space-y-6">
        {/* Header avec titre */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Parc LuniShower</h1>
        </div>

        {/* Barre de recherche */}
        <div className="mb-4">
          <div className="relative inline-block" style={{ minWidth: "250px" }}>
            <AiOutlineSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
            <input type="text" placeholder="Rechercher un hôtel..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-gray-400" />
            {searchTerm && (
              <button onClick={() => setSearchTerm("")} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Effacer la recherche">
                <AiOutlineClose size={18} />
              </button>
            )}
          </div>
        </div>

        {/* Message si aucun résultat de recherche */}
        {searchTerm.trim() ? (
          <div className="bg-white shadow-md rounded-lg p-8 text-center">
            <div className="text-black text-lg">Aucun hôtel LuniShower trouvé pour "{searchTerm}"</div>
          </div>
        ) : (
          <div className="bg-white shadow-md rounded-lg p-8 text-center">
            <div className="text-gray-500 text-lg">Aucun hôtel LuniShower disponible pour le moment.</div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header avec titre */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Parc LuniShower</h1>
      </div>

      {/* Barre de recherche */}
      <div className="mb-4">
        <div className="relative inline-block" style={{ minWidth: "250px" }}>
          <AiOutlineSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
          <input type="text" placeholder="Rechercher un hôtel..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-gray-400" />
          {searchTerm && (
            <button onClick={() => setSearchTerm("")} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Effacer la recherche">
              <AiOutlineClose size={18} />
            </button>
          )}
        </div>
      </div>

      {/* Résumé */}
      <HotelsSummary totalHotels={hotels.length} />

      {/* Message si aucun résultat de recherche */}
      {!loadingStats && searchTerm.trim() && hotels.length === 0 && (
        <div className="bg-white shadow-md rounded-lg p-8 text-center">
          <div className="text-black text-lg">Aucun hôtel LuniShower trouvé pour "{searchTerm}"</div>
        </div>
      )}

      {/* Table des hôtels */}
      {hotels.length > 0 && (
        <div className="bg-white shadow-md rounded-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <SortableTableHeader column="name" currentColumn={sortState.column} currentDirection={sortState.direction} onSort={onSort} className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Nom de l'hôtel
                  </SortableTableHeader>

                  <SortableTableHeader column="performance" currentColumn={sortState.column} currentDirection={sortState.direction} onSort={onSort} className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    % OK
                    <br />
                    <span className="text-gray-400 normal-case">(Performance)</span>
                  </SortableTableHeader>

                  <SortableTableHeader column="room_status" currentColumn={sortState.column} currentDirection={sortState.direction} onSort={onSort} className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Statuts
                  </SortableTableHeader>

                  <SortableTableHeader column="room_count" currentColumn={sortState.column} currentDirection={sortState.direction} onSort={onSort} className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Nb de Chambres
                  </SortableTableHeader>

                  <th className="px-2 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {hotels.map((hotel) => (
                  <LuniShowerHotelRow key={hotel.id} hotel={hotel} onUpdateStatus={onUpdateStatus} onEditDescription={onEditDescription} loadingStats={isStatsLoading(hotel)} />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default LuniShowerHotelsTable;
